// extracted by mini-css-extract-plugin
module.exports = {"incomeCalculatorRequiredQuestionOneText":"IncomeCalculator_incomeCalculatorRequiredQuestionOneText__A-zD0"};